import { createMetricsFactory } from 'metrics-js';
export const Metrics = createMetricsFactory('quartz-core', {
  library: 'quartz-core'
});